import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import Api from '../../Apis/api.service'
import mock_data from './mock/data.json'
import { OpposantsActions, OpposantsContent, OpposantsHeader } from './partials'

const OpposantsDefaillants = () => {
  const { id } = useParams()
  const [informations, setInformations] = useState(null)
  const [loadingData, setLoadingData] = useState(false)
  const [data, setData] = useState([])

  useEffect(() => {
    getInformations(id)
  }, [id])

  useEffect(() => {
    getData()
  }, [])

  const getInformations = async (id) => {
    const res = await Api.ags.getOpponentInformations(id)
    if (res.status == 200) {
      setInformations({ ...res.data })
    } else {
      setInformations(null)
    }
  }
  const getData = async () => {
    setLoadingData(true)
    const res = await Api.ags.getOpponents(id)
    if (res.status == 200) {
      setData(res.data)
    } else {
      setData([])
    }
    setLoadingData(false)
  }

  const refresh = async () => {
    await getInformations(id)
    await getData()
  }

  return (
    <>
      <OpposantsHeader id={id} informations={informations} />
      <OpposantsActions
        id={id}
        informations={informations}
        refresh={async () => {
          await refresh()
        }}
      />
      <OpposantsContent id={id} data={data} loadingData={loadingData} />
    </>
  )
}
export default OpposantsDefaillants
